import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";
export const enquiryApi = createApi({
  reducerPath: "enquiryApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  tagTypes: ["Enquiry"],
  endpoints: (builder) => ({
    getAllEnquiry: builder.query({
      query: (Token) => ({
        url: "/enquiry",
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Enquiry"],
    }),
    SaveEnquiry: builder.mutation({
      query: ({ Token, enquiryData }) => ({
        url: "/enquiry",
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: enquiryData,
      }),
      invalidatesTags: ["Enquiry"],
    }),
    EditEnquiry: builder.mutation({
      query: ({ id, Token, enquiryData }) => ({
        url: `/enquiry/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: enquiryData,
      }),
      invalidatesTags: ["Enquiry"],
    }),
    DeleteEnquiry: builder.mutation({
      query: ({ id, Token }) => ({
        url: `/enquiry/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      invalidatesTags: ["Enquiry"],
    }),
    SendEmail: builder.mutation({
      query: ({ id, Token }) => ({
        url: `/enquiry/send-reminder/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      invalidatesTags: ["Enquiry"],
    }),
    ChangeEnquiryStatus: builder.mutation({
      query: ({ id, Token, data }) => ({
        url: `enquiry/update-status/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: data,
      }),
      invalidatesTags: ["Enquiry"],
    }),
  }),
});

export const {
  useGetAllEnquiryQuery,
  useSaveEnquiryMutation,
  useEditEnquiryMutation,
  useDeleteEnquiryMutation,
  useSendEmailMutation,
  useChangeEnquiryStatusMutation,
} = enquiryApi;
